import { render, staticRenderFns } from "./TypeAppendix.vue?vue&type=template&id=58cbdbe6"
import script from "./TypeAppendix.vue?vue&type=script&lang=js"
export * from "./TypeAppendix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports